import { Component, Input } from '@angular/core';
import { FormGroup, UntypedFormControl } from '@angular/forms';
import { ValidationService } from './validation.service';

@Component({
    selector: 'control-messages',
    template: `<br /><div *ngIf="errorMessage !== null" style="font-size:10px;color:red;">{{errorMessage}}</div>`,
    standalone: false
})
export class ControlMessagesComponent {
    @Input() control: UntypedFormControl;
    constructor() { }

    get errorMessage() {
        for (const propertyName in this.control.errors) {
            if (this.control.errors.hasOwnProperty(propertyName) && this.control.touched) {
                return ValidationService.getValidatorErrorMessage(propertyName, this.control.errors[propertyName]);
            }
        }

        return null;
    }
}